import React from "react";
import "./style.scss";
import logoIcon from "../../../assets/icons/acg-logo.png";
import checkIcon from "../../../assets/icons/check-icon-blue.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import { validateEmail } from "../../../utils/helpers/string";
import Spinner from "../../../reusableComponents/spinner/Spinner";
import { resetPasswordReq } from "../../../utils/apis/userApi";
import { useDispatch } from "react-redux";
import { returnMessages } from "../../../utils/store/reducers/Message";
import { returnErrors } from "../../../utils/store/reducers/Error";

const ForgotPasswordForm = () => {
  const inputs = {
    email: "",
  };

  const schema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
  });
  const dispatch = useDispatch();
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormik({
    initialValues: inputs,
    validationSchema: schema,
    onSubmit: async (values, { setSubmitting }) => {
      const formData = new FormData();
      formData.append("email", values.email);
      try {
        const response = await resetPasswordReq(formData);
        
        if (response.status < 399) {
          const msg = `An email has been sent to ${values.email} with instructions for resetting your password.`;
          dispatch(returnMessages(msg, 200));
          // Handle success (e.g., show a success message or redirect)
        }
      } catch (error) {
        console.error("Error resetting password:", error);
          dispatch(returnErrors(error?.response.data.detail||"something went wrong.", 400));

      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="forgotpasswordform-container">
      <div className="forgotpasswordform-wrapper">
        <div className="company-logo">
          <img src={logoIcon} alt="company-logo" />
        </div>
        <div className="forgotpasswordform-form-info">
          <h2 className="form-header">Forgot password</h2>
          <p className="form-caption">
            Don't worry! It happens. Please enter the email address associated
            with your account.
          </p>
        </div>
        <form
          className="forgotpasswordform-innercontainer"
          onSubmit={handleSubmit}
        >
          <div className="forgotpasswordform-subcontainer-form">
            <div className="input-wrapper">
              <p className="input-label">Email</p>
              <label
                className={`forgotpasswordform-container-input ${
                  touched.email && errors.email && "form-empty-input"
                }`}
                htmlFor="email"
              >
                <input
                  type="text"
                  className="forgotpasswordform-input-box"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Your Email address"
                  id="email"
                />
                {validateEmail(values.email) && (
                  <img src={checkIcon} alt="Valid email" />
                )}
              </label>
            </div>
            {touched.email && errors.email && (
              <div className="form-error-message">{errors.email}</div>
            )}
          </div>
          <div className="forgotpasswordform-submit-option">
            <button
              className="submit-button standard-button"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? <Spinner /> : "Continue"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
